<template>
  <div v-if="loadFiche === 0">
    <Loader />
  </div>

  <div class="fiche-cours" v-if="loadFiche === 1">

    <!-- ===== HEADER CARD ===== -->
    <div class="cours-header-card">
      <div class="cours-meta cours-meta--grid">
        <div class="cours-col">
          <div class="cours-title-row">
            <div class="cours-title">
              Cours
              <span v-if="this.apointment.statutAac != 'null'"> — {{ statutAacLabel }}</span>
            </div>
            <span class="badge badge-red">{{ this.eleve.boite }}</span>
            <template v-if="this.eleve.aac">
              <img src="../../../assets/images/conduite/aac.png" class="logo-aac" alt="AAC" />
            </template>
          </div>
          <div class="cours-info-row">
            <span class="cours-student">{{ this.eleve.prenom }} {{ this.eleve.nom.toUpperCase() }}</span>
            <span class="cours-hours">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:4px;vertical-align:-2px">
                <rect x="2" y="14" width="4" height="8" rx="1"/>
                <rect x="10" y="9" width="4" height="13" rx="1"/>
                <rect x="18" y="4" width="4" height="18" rx="1"/>
              </svg>
              <b>{{ this.eleve.niveau }}</b>%
            </span>
            <span class="cours-hours cours-hours--clickable" @click="showHisto">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:4px;vertical-align:-2px"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
              <b>{{ this.eleve.heureFaites }}</b>h faites
            </span>
          </div>
          <div class="cours-info-row">
            <span class="badge badge-amber">{{ this.eleve.exam }}</span>
            <span class="badge badge-blue" v-if="this.eleve.aac">
              <template v-if="this.eleve.dateRdvp !== 'RDVP NON PROG'">RDVP : {{ this.eleve.dateRdvp }}</template>
              <template v-else>{{ this.eleve.dateRdvp }}</template>
            </span>
          </div>
        </div>

        <div class="cours-col-divider"></div>

        <div class="cours-col cours-col-equation">
          <div class="heure-equation">
            <div class="heure-box">
              <span class="heure-box-value">{{ eleve.heureRestanteTrame }}h</span>
              <span class="heure-box-label">H pour finir</span>
            </div>
            <span class="heure-op">-</span>
            <div class="heure-box heure-box-clickable" @click="showHeuresProgrammeesDialog = true">
              <span class="heure-box-value">{{ eleve.heureProgFutur }}h</span>
              <span class="heure-box-label">{{ heureProgrammeesLabel }}</span>
            </div>
            <span class="heure-op">=</span>
            <div class="heure-box heure-box-highlight">
              <span class="heure-box-value">{{ eleve.heureApgmer }}h</span>
              <span class="heure-box-label">H à programmer</span>
            </div>
          </div>
        </div>
      </div>
      <div class="cours-header-right">
        <button class="btn btn-secondary btn-sm" @click="cancelRdv" v-if="this.$store.state.rdvStart != true">
          ✕
        </button>
      </div>
    </div>

    <!-- ===== TOOLBAR ===== -->
    <div class="cours-toolbar" v-if="this.$store.state.rdvStart != true">
      <p class="rdv-day">{{ this.apointment.jour }}</p>

      <div class="rdv-times">
        <div class="rdv-slot">
          <span class="rdv-slot-label">Début</span>
          <span class="rdv-slot-value">{{ this.apointment.debut.heure }}h — {{ this.apointment.debut.lieu }}</span>
        </div>
        <div class="rdv-separator">/</div>
        <div class="rdv-slot">
          <span class="rdv-slot-label">Fin</span>
          <span class="rdv-slot-value">{{ this.apointment.fin.heure }}h — {{ this.apointment.fin.lieu }}</span>
        </div>
      </div>

      <div class="toolbar-actions">
        <button class="btn btn-green" @click="startRdv" v-if="this.$store.state.rdvStart === null">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="5 3 19 12 5 21 5 3"/></svg>
          DÉBUTER LE COURS
        </button>
        <button class="btn btn-red" @click="handleTerminerCours" v-if="this.$store.state.rdvStart === false">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
          TERMINER LE COURS
        </button>

        <div class="legend-row">
          <span class="legend-label">Légende :</span>
          <span class="legend-dot">
            <span class="legend-pip pip-amber"></span>
            <span class="pip-text amber">Débuté</span>
          </span>
          <span class="legend-dot">
            <span class="legend-pip pip-blue"></span>
            <span class="pip-text blue">Assimilé</span>
          </span>
          <span class="legend-dot">
            <span class="legend-pip pip-green"></span>
            <span class="pip-text green">Parfaitement assimilé</span>
          </span>
        </div>
      </div>
    </div>

    <!-- ===== SECTION NAV (carrousel) ===== -->
    <div class="section-nav" v-if="this.$store.state.rdvStart !== null">
      <button class="nav-arrow-btn" @click="subCarrousel" v-if="this.$store.state.rdvStart === false">&#8249;</button>
      <button class="nav-arrow-btn" @click="goBackToStart" v-if="this.$store.state.rdvStart === true">&#8249;</button>
      <div class="section-title">{{ this.titleCarrousel }}</div>
      <button class="nav-arrow-btn" @click="addCarrousel" v-if="this.$store.state.rdvStart === false">&#8250;</button>
    </div>

    <!-- ===== SYNTHESE NAV (vue synthèse) ===== -->
    <div class="section-nav" v-if="this.$store.state.rdvStart === null">
      <button class="nav-arrow-btn goBack" @click="goBackToSynth" v-if="index != null">&#8249;</button>
      <div class="section-title">{{ this.titleCarrousel }}</div>
    </div>

    <!-- ===== SYNTHESE GRID — donuts ===== -->
    <div class="synthese-grid" v-if="this.compSelec.length === 0 && this.$store.state.rdvStart != true">
      <div
        class="competence-item-wrap"
        v-for="(competence, index) in competences"
        :key="index"
      >
        <div class="competence-label-top">{{ competence.nom }}</div>
        <div class="competence-card" @click="getCompetence(competence)">
          <div class="competence-progress-row">
            <div class="competence-progress-bar">
              <div
                class="competence-progress-fill"
                :style="{ width: competence.pourcent + '%', background: donutColor(competence.pourcent) }"
              ></div>
            </div>
            <span class="competence-progress-label" :style="{ color: donutColor(competence.pourcent) }">{{ competence.pourcent }}%</span>
          </div>
          <div class="donut-wrap">
            <svg viewBox="0 0 36 36">
              <circle cx="18" cy="18" r="15.9155" fill="none" stroke="#f1f5f9" stroke-width="3.5"/>
              <circle
                cx="18" cy="18" r="15.9155" fill="none"
                :stroke="donutColor(competence.pourcent)"
                stroke-width="3.5"
                :stroke-dasharray="competence.pourcent + ' ' + (100 - competence.pourcent)"
                stroke-linecap="round"
              />
            </svg>
            <div class="donut-center" :style="{ color: donutColor(competence.pourcent) }">
              {{ competence.heuresAFaire != null ? formatMinutes(competence.heuresAFaire) : competence.pourcent + '%' }}
            </div>
          </div>
          <span class="competence-heures" v-if="competence.heuresAFaire != null">{{ formatMinutes(competence.heuresAFaire) }} pour compléter cette compétence</span>
        </div>
      </div>
    </div>

    <!-- ===== COMPETENCE DETAIL ===== -->
    <div
      class="competence-detail"
      v-if="this.compSelec.length != 0 && this.$store.state.rdvStart != true || index == null && this.$store.state.rdvStart != true && this.compSelec.length != 0"
    >
      <template v-for="(obj, i) in compSelec.objs" :key="i">
        <div class="competence-section">
          <div class="competence-section-header">
            <div
              class="competence-section-check"
              :class="{
                'check-full': obj.fait >= obj.tot,
                'check-assimile': obj.fait >= obj.tot * 0.666 && obj.fait < obj.tot,
                'check-partial': obj.fait >= obj.tot / 3 && obj.fait < obj.tot * 0.666,
                'check-empty': obj.fait < obj.tot / 3
              }"
            >
              <svg v-if="obj.fait >= obj.tot" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
              <span v-else-if="obj.fait >= obj.tot / 3">~</span>
            </div>
            <div class="competence-section-title">{{ obj.label }}</div>
            <span class="duree-restante" v-if="obj.dureeRestante != null">{{ obj.dureeRestante }} min restantes</span>
          </div>

          <div class="competence-items">
            <div class="competence-item" v-for="(ssobj, index) in obj.ssobjs" :key="index">
              <select
                class="item-select"
                :class="{
                  'parfait': ssobj.status === 3,
                  'assimile': ssobj.status === 2,
                  'debutant': ssobj.status === 1
                }"
                :value="ssobj.status"
                @change="setSsObj"
                :data-status="ssobj.status"
                data-type="ssobj"
                :data-id="ssobj.id"
                :data-idComp="this.compSelec.id"
              >
                <option :value="0">Non traité</option>
                <option :value="1">Débuté</option>
                <option :value="2">Assimilé</option>
                <option :value="3" :disabled="eleve.aac === true && eleve.aacEnd !== true && apointment.statutAac !== 'rdvp2'">Parfaitement Assimilé</option>
              </select>
              <span class="item-label">{{ ssobj.label }}</span>
              <span class="duree-restante" v-if="ssobj.dureeRestante != null">{{ ssobj.dureeRestante }} min restantes</span>
            </div>
          </div>
        </div>
      </template>
    </div>

    <!-- ===== TERMINER LE COURS ===== -->
    <div class="terminer-card" v-if="this.$store.state.rdvStart === true">

      <!-- Étape 1 -->
      <div class="terminer-section">
        <div class="terminer-section-label">
          <div class="terminer-section-num">1</div>
          Nombre d'heures à prévoir
        </div>
        <div class="hours-input-row">
          <span class="hours-base">{{ this.eleve.info.heureRestanteTrame }}h</span>
          <span class="hours-plus">+</span>
          <input type="number" class="hours-number-input" v-model="heureAPrevoir" min="0" />
          <span class="hours-total">= {{ heureTotAPrevoir }}h</span>
        </div>
      </div>

      <!-- Étape 2a — Proposer à l'examen -->
      <div
        class="terminer-section"
        v-if="(this.eleve.info.aacStatus == 'null' || this.eleve.info.aacStatus == 'fin') && this.eleve.niveau >= this.eleve.examProgress"
      >
        <div class="terminer-section-label">
          <div class="terminer-section-num">2</div>
          Proposer à l'examen
        </div>
        <button class="btn btn-danger" @click="showExamFormDiv" v-if="loadBtn === false">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
          EXAMEN
        </button>
        <button class="btn btn-danger" @click="showExamFormDiv" v-else disabled>
          <i class="fa fa-spinner fa-spin"></i> EXAMEN
        </button>

        <div class="exam-form" v-if="showExamForm">
          <MultiSelect
            class="exam-multiselect"
            v-model="lieu"
            :options="lieux"
            optionValue="id"
            optionLabel="nom"
            placeholder="Lieux d'examen"
            :disabled="desac"
          />
          <p class="exam-form-hint">Un lieu choisi ici propose automatiquement l'élève à l'examen en terminant le cours ci-dessous.</p>
        </div>

        <div class="success-block" v-if="demandeExam">
          ✅ La demande d'examen a bien été prise en compte.
        </div>
      </div>

      <!-- Étape 2b — AAC rdvp -->
      <div class="terminer-section" v-if="this.apointment.statutAac != 'null' && this.eleve.info.aacStatus === 'rdvp'">
        <div class="terminer-section-label">
          <div class="terminer-section-num">2</div>
          Le {{ this.eleve.info.aacStatus }} est-il validé ?
        </div>
        <div class="aac-validate-row">
          <button class="btn btn-green" @click="this.aacRdvValide = true;">OUI</button>
          <button class="btn btn-danger" @click="this.aacRdvValide = false;">NON</button>
        </div>
        <p class="aac-result" v-if="aacRdvValide === false">Le {{ this.eleve.info.aacStatus }} n'a pas été validé.</p>
        <p class="aac-result success" v-if="aacRdvValide === true">Le {{ this.eleve.info.aacStatus }} a été validé.</p>
      </div>

      <!-- Étape 3 — Commentaire -->
      <div class="terminer-section">
        <div class="terminer-section-label">
          <div class="terminer-section-num">3</div>
          Mettre un commentaire
        </div>
        <textarea class="comment-area" v-model="commentaire" placeholder="Saisir un commentaire sur ce cours…"></textarea>
      </div>

      <div class="terminer-footer">
        <button class="btn btn-red" @click="doneRdv" :disabled="isRdvpValidationMissing || loadBtn" v-if="!loadBtn">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
          TERMINER LE COURS
        </button>
        <button class="btn btn-red" disabled v-else>
          <i class="fa fa-spinner fa-spin"></i> TERMINER LE COURS
        </button>
        <p class="aac-result" v-if="isRdvpValidationMissing">Merci de répondre à la question ci-dessus avant de terminer le cours.</p>
      </div>

    </div>

    <!-- ===== MODAL HISTORIQUE ===== -->
    <Dialog v-model:visible="historicBtn" modal header="Historique des RDV" :style="{ width: '90vw', maxWidth: '600px' }">
      <template v-for="a in apointmentsDone" :key="a.date">
        <div class="histo-item">
          <div class="histo-header">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            {{ a.moniteur }} — {{ a.date }}
          </div>
          <div class="histo-body">
            <p v-if="a.commentaire === null" class="histo-empty">Pas de commentaire</p>
            <p v-else>{{ a.commentaire }}</p>
          </div>
        </div>
      </template>
    </Dialog>

    <Dialog
      v-model:visible="showHeuresProgrammeesDialog"
      modal
      :header="heuresProgrammeesDialogTitle"
      :style="{ width: '70vw', maxWidth: '1000px' }"
    >
      <div class="heures-prog-list">
        <div class="heures-prog-empty" v-if="heuresProgrammeesList.length === 0">Aucune heure programmée à venir</div>
        <div class="heures-prog-row" v-for="(h, index) in heuresProgrammeesList" :key="index">
          <span class="heures-prog-date">{{ h.jour }}</span>
          <span class="heures-prog-heure">{{ h.debut.heure }}h — {{ h.fin.heure }}h</span>
          <span class="heures-prog-lieu">
            <template v-if="h.debut.lieu === h.fin.lieu">{{ h.debut.lieu }}</template>
            <template v-else>{{ h.debut.lieu }} → {{ h.fin.lieu }}</template>
          </span>
          <span class="heures-prog-mono" v-if="h.moniteur">{{ h.moniteur }}</span>
        </div>
      </div>
    </Dialog>

  </div>
</template>


<script>
import Loader from "@/components/Loader.vue";
import moment from "moment";

export default {
  props: ["idRdv", "cancelFicheRdv"],

  components: { Loader },

  watch: {
    heureAPrevoir: function () {
      this.heureTotAPrevoir = this.eleve.info.heureRestanteTrame + this.heureAPrevoir;
    },
  },

  data() {
    return {
      loadFiche: 0,
      eleve: [],
      apointment: [],
      competences: [],
      titleCarrousel: "SYNTHESE",
      index: null,
      compSelec: [],
      heureAPrevoir: 0,
      heureTotAPrevoir: 0,
      apAac: "",
      aacRdvValide: null,
      commentaire: "",
      lieux: [],
      lieu: "",
      loadBtn: false,
      showExamForm: false,
      demandeExam: false,
      historicBtn: false,
      apointmentsDone: [],
      showHeuresProgrammeesDialog: false,
    };
  },

  mounted() {
    this.getCoursInfo();
    this.getLieuBoite();
  },

  computed: {
    isRdvpValidationMissing() {
      return (
        this.apointment.statutAac != 'null' &&
        this.eleve.info.aacStatus === 'rdvp' &&
        this.aacRdvValide === null
      );
    },

    heuresProgrammeesList() {
      return (this.eleve.apointmentsAVenir || []).filter((a) =>
        a.statutAac !== "rdvp" && a.statutAac !== "rdvp1" && a.statutAac !== "rdvp2"
      );
    },

    heureProgrammeesLabel() {
      if (!this.eleve.aac || this.eleve.rdvpFait) {
        return "H programmées";
      }
      return "H programmées avant RDV préalable";
    },

    heuresProgrammeesDialogTitle() {
      if (!this.eleve.aac || this.eleve.rdvpFait) {
        return "Heures programmées à venir";
      }
      let title = "Heures programmées à venir avant le RDV préalable";
      if (this.eleve.dateRdvp && this.eleve.dateRdvp !== "RDVP NON PROG") {
        title += " du " + this.eleve.dateRdvp;
      }
      return title;
    },

    statutAacLabel() {
      if (this.apointment.statutAac === "rdvp") return "RDV PREALABLE - " + this.apointment.jour;
      if (this.apointment.statutAac === "rdvp1") return "RDV PEDAGO 1";
      if (this.apointment.statutAac === "rdvp2") return "RDV PEDAGO 2";
      return this.apointment.statutAac;
    },
  },

  methods: {
    donutColor(pourcent) {
      if (pourcent >= 100) return "#22c55e";
      if (pourcent >= 50) return "#3b82f6";
      if (pourcent >= 1) return "#f59e0b";
      return "#ef4444";
    },

    formatMinutes(minutes) {
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      return m === 0 ? h + "h" : h + "h" + String(m).padStart(2, "0");
    },

    showExamFormDiv() {
      this.loadBtn = true;
      window.api
        .get("/can/demande/" + this.eleve.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          if (response.data.demande === false) {
            alert("L'élève n'a pas un solde suffisant pour pouvoir demander une date d'examen, il doit avoir au minimum " + response.data.limite + "€ en solde. Veuillez contacter votre agence");
            this.loadBtn = false;
          } else if (response.data.dateProb !== "") {
            alert("L'élève ne peut pas faire de demande d'examen il doit attendre le : " + response.data.dateProb + " ou passer par l'agence");
            this.loadBtn = false;
          } else {
            this.loadBtn = false;
            this.showExamForm = !this.showExamForm;
          }
        })
        .catch((error) => { console.log(error); });
    },

    getLieuBoite() {
      window.api
        .get("/boite/lieu/exam/", { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => { this.lieux = response.data.lieux; })
        .catch((error) => { console.log(error); });
    },

    // Un lieu d'examen choisi (section "Proposer à l'examen") fait aussi partie de ce même clic :
    // on envoie la demande d'examen avant de terminer le cours, pour n'avoir qu'un seul bouton.
    lieuExamenChoisi() {
      return !!this.lieu && (!Array.isArray(this.lieu) || this.lieu.length > 0);
    },

    doneRdv() {
      if (this.isRdvpValidationMissing) {
        alert("Merci de répondre à la question 'Le RDVP est-il validé ?' avant de terminer le cours.");
        return;
      }

      if (this.lieuExamenChoisi() && !window.confirm("Terminer ce cours et proposer cet élève à l'examen ?")) {
        return;
      }

      this.loadBtn = true;

      if (this.lieuExamenChoisi()) {
        window.api
          .post("/set/demande/exam/null/null", {
            id: this.eleve.id,
            ids: this.$store.state.user.id,
            idMono: this.$store.state.user.idMono,
            lieu: this.lieu,
            commentaire: "",
          }, { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then(() => { this.demandeExam = true; this.terminerLeCours(); })
          .catch((error) => { console.log(error); this.loadBtn = false; });
      } else {
        this.terminerLeCours();
      }
    },

    terminerLeCours() {
      let nowDate = new Date();
      window.api
        .post("/end/rdv/" + this.apointment.id, {
          heurePrea: this.heureAPrevoir,
          aacRdvValide: this.aacRdvValide,
          apAac: this.apAac,
          commentaire: this.commentaire,
          now: moment(nowDate.date).format("YYYY-MM-DDTHH:mm:ss"),
        }, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => {
          if (response.data.message == "finish") this.$emit("cancelFicheRdv");
          window.location.reload();
        })
        .catch((error) => { console.log(error); this.loadBtn = false; });
    },

    subCarrousel() {
      if (this.index == 0) {
        this.index = null;
        this.compSelec = [];
        this.titleCarrousel = "SYNTHESE";
      } else {
        this.index = this.index === null ? this.competences.length - 1 : this.index - 1;
        window.api
          .get("/competence/" + this.eleve.id + "/" + this.index, { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then((response) => { this.compSelec = response.data.comp[0]; this.titleCarrousel = this.compSelec.label; })
          .catch((error) => { console.log(error); });
      }
    },

    addCarrousel() {
      if (this.index == this.competences.length - 1) {
        this.index = null;
        this.compSelec = [];
        this.titleCarrousel = "SYNTHESE";
      } else {
        this.index = this.index === null ? 0 : this.index + 1;
        window.api
          .get("/competence/" + this.eleve.id + "/" + this.index, { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then((response) => { this.compSelec = response.data.comp[0]; this.titleCarrousel = this.compSelec.label; })
          .catch((error) => { console.log(error); });
      }
    },

    setSsObj(e) {
      if (this.$store.state.rdvStart === null) {
        alert("Veuillez commencer le cours pour pouvoir apporter des modifications");
        // Le select n'est plus lié par v-model (cf. :value), donc on doit remettre
        // manuellement l'ancienne valeur affichée puisque le navigateur a déjà changé
        // la sélection visuellement avant que ce handler ne bloque la modification.
        e.target.value = e.target.dataset.status;
      } else {
        let status = parseInt(e.target.value);
        window.api
          .get("/set/ssobj/" + this.eleve.id + "/" + e.target.dataset.idcomp + "/" + e.target.dataset.id + "/" + status, { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then((response) => {
            this.compSelec = response.data.comp[0];
            this.competences = response.data.competences;
            this.refreshEleveHeures();
          })
          .catch((error) => { console.log(error); });
      }
    },

    refreshEleveHeures() {
      window.api
        .get("/moniteur/cours/" + this.idRdv, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => {
          this.eleve.heureFaites = response.data.eleve.heureFaites;
          this.eleve.heureApgmer = response.data.eleve.heureApgmer;
          this.eleve.heureProgFutur = response.data.eleve.heureProgFutur;
          this.eleve.heureRestanteTrame = response.data.eleve.heureRestanteTrame;
          this.eleve.niveau = response.data.eleve.niveau;
        })
        .catch((error) => { console.log(error); });
    },

    getCompetence(comp) {
      window.api
        .get("/competence/" + this.eleve.id + "/" + comp.index, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => { this.index = comp.index; this.compSelec = response.data.comp[0]; this.titleCarrousel = this.compSelec.label; })
        .catch((error) => { console.log(error); });
    },

    goBackToSynth() { this.index = null; this.compSelec = []; },

    handleTerminerCours() {
      this.endRdv();
    },

    startRdv() { this.$store.commit("setRdvStart", false); },

    endRdv() {
      window.api
        .get("/eleve/info/endrdv/" + this.eleve.id + "?apId=" + this.apointment.id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => {
          this.eleve.info = response.data.eleveInfo[0];
          // rdvp1/rdvp2 : validés automatiquement, plus de question à l'écran (seul le rdvp la garde)
          if (this.eleve.info.aacStatus === 'rdvp1' || this.eleve.info.aacStatus === 'rdvp2') {
            this.aacRdvValide = true;
          }
          this.heureAPrevoir = this.eleve.info.heurePreco;
          // Recalcul explicite : le watcher ne se déclenche pas si heurePreco === 0 (valeur inchangée)
          this.heureTotAPrevoir = this.eleve.info.heureRestanteTrame + this.eleve.info.heurePreco;
          // Synchronise aussi la valeur affichée dans le header
          this.eleve.heureTot = this.eleve.info.heureTot;
          this.eleve.niveau   = this.eleve.info.niveau;
          this.$store.commit("setRdvStart", true);
          this.titleCarrousel = "Terminer le cours";
        })
        .catch((error) => { console.log(error); });
    },

    goBackToStart() {
      this.index = null;
      this.titleCarrousel = "SYNTHESE";
      this.eleve.info = "";
      this.compSelec = [];
      this.$store.commit("setRdvStart", false);
    },

    cancelRdv() {
      this.$store.commit("setRdvStart", null);
      this.$emit("cancelFicheRdv");
    },

    showHisto() {
      window.api
        .get("/historique/eleve/" + this.eleve.id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => { this.apointmentsDone = response.data.apointments; this.historicBtn = true; })
        .catch((error) => { console.log(error); });
    },

    getCoursInfo() {
      window.api
        .get("/moniteur/cours/" + this.idRdv, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((response) => {
          this.eleve = response.data.eleve;
          this.apointment = response.data.apointments;
          this.competences = response.data.competences;
          this.loadFiche++;
          this.heureTotAPrevoir = this.eleve.heureTot;
        })
        .catch((error) => { console.log(error); });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=DM+Serif+Display&display=swap');

*, *::before, *::after { box-sizing: border-box; }

/* ===== WRAPPER ===== */
.fiche-cours {
  background: #f4f6f9;
  min-height: 100vh;
  color: #1a1f2e;
  padding: 24px;
}

/* ===== HEADER CARD ===== */
.cours-header-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}

.cours-meta { display: flex; flex-direction: column; gap: 6px; }

.cours-meta--grid {
  flex-direction: row;
  align-items: stretch;
  gap: 20px;
}

.cours-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
}

.cours-col-divider {
  width: 1px;
  background: #e2e8f0;
  align-self: stretch;
}

.cours-row {
  font-size: 13px;
  color: #64748b;
  display: flex;
  align-items: center;
}

.cours-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.cours-title {
  font-size: 20px;
  color: #1a1f2e;
  letter-spacing: -.3px;
}

.logo-aac { width: 22px; vertical-align: middle; }

.cours-info-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.cours-student { font-size: 14px; font-weight: 600; color: #1a1f2e; }

.cours-hours { font-size: 13px; color: #64748b; display: flex; align-items: center; }

.cours-hours--clickable { cursor: pointer; }
.cours-hours--clickable:hover { color: #1a1f2e; text-decoration: underline; }

.cours-hours-sub { font-size: 12px; color: #94a3b8; }

.cours-header-right { display: flex; align-items: center; gap: 10px; }

/* ===== EQUATION HEURES A PROGRAMMER ===== */
.cours-col-equation { justify-content: center; }

.heure-equation {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.heure-equation .heure-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 10px;
  border-radius: 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.heure-equation .heure-box-value {
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
}

.heure-equation .heure-box-label {
  font-size: 9px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

.heure-equation .heure-op {
  font-size: 14px;
  font-weight: 700;
  color: #94a3b8;
}

.heure-equation .heure-box-highlight {
  background: #e8f7ee;
  border-color: #37dd69;
}

.heure-equation .heure-box-highlight .heure-box-value {
  color: #15803d;
}

.heure-equation .heure-box-highlight .heure-box-label {
  color: #16a34a;
}

.heure-equation .heure-box-clickable {
  cursor: pointer;
  transition: background .15s, border-color .15s;
}

.heure-equation .heure-box-clickable:hover {
  background: #e8f0fe;
  border-color: #93c5fd;
}

/* ===== BADGE ===== */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .01em;
}
.badge-red    { background: #fee2e2; color: #b91c1c; }
.badge-amber  { background: #fef3c7; color: #b45309; }
.badge-green  { background: #e8f7f1; color: #065f46; }
.badge-blue   { background: #eff6ff; color: #1d4ed8; }
.badge-gray   { background: #f1f5f9; color: #64748b; }

/* ===== BUTTONS ===== */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all .15s;
  white-space: nowrap;
}
.btn:disabled { opacity: .6; cursor: not-allowed; }

.btn-primary  { background: #3b82f6; color: #fff; }
.btn-primary:hover:not(:disabled) { background: #2563eb; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,130,246,.3); }

.btn-secondary { background: #f4f6f9; color: #64748b; border: 1px solid #e2e8f0; }
.btn-secondary:hover { background: #fff; color: #1a1f2e; }

.btn-green  { background: #1a9e6e; color: #fff; }
.btn-green:hover { background: #168a5f; transform: translateY(-1px); }

.btn-danger { background: #fee2e2; color: #ef4444; border: 1px solid #fca5a5; }
.btn-danger:hover:not(:disabled) { background: #fecaca; }

.btn-red    { background: #ef4444; color: #fff; }
.btn-red:hover { background: #dc2626; transform: translateY(-1px); }

.btn-sm { padding: 5px 11px; font-size: 11px; border-radius: 8px; }

/* ===== TOOLBAR ===== */
.cours-toolbar {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.rdv-day {
  font-size: 17px;
  color: #1a1f2e;
  margin: 0;
}

.rdv-times {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.rdv-slot { display: flex; flex-direction: column; gap: 2px; }

.rdv-slot-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #94a3b8;
}

.rdv-slot-value { font-size: 13px; font-weight: 600; color: #1a1f2e; }

.rdv-separator { font-size: 24px; color: #e2e8f0; font-weight: 300; }

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.legend-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
  flex-wrap: wrap;
}

.legend-label { font-weight: 600; }

.legend-dot { display: inline-flex; align-items: center; gap: 5px; }

.legend-pip {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 3px;
}
.pip-amber  { background: #f59e0b; }
.pip-blue   { background: #3b82f6; }
.pip-green  { background: #1a9e6e; }

.pip-text.amber { color: #f59e0b; font-weight: 600; }
.pip-text.blue  { color: #3b82f6; font-weight: 600; }
.pip-text.green { color: #1a9e6e; font-weight: 600; }

/* ===== SECTION NAV ===== */
.section-nav {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.nav-arrow-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 18px;
  transition: all .12s;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  flex-shrink: 0;
}
.nav-arrow-btn:hover { background: #f4f6f9; color: #1a1f2e; border-color: #94a3b8; }

.section-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  color: #1a1f2e;
  letter-spacing: -.3px;
}

/* ===== SYNTHESE GRID ===== */
.synthese-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.competence-item-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.competence-label-top {
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #1a1f2e;
  line-height: 1.4;
}

.competence-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition: box-shadow .15s, transform .15s;
}
.competence-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,.08); transform: translateY(-2px); }

.competence-progress-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.competence-progress-bar {
  flex: 1;
  height: 8px;
  background: #f1f5f9;
  border-radius: 999px;
  overflow: hidden;
}
.competence-progress-fill {
  height: 100%;
  border-radius: 999px;
  transition: width .2s;
}
.competence-progress-label {
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.competence-heures {
  font-size: 12px;
  font-weight: 700;
  color: #ef4444;
}

.donut-wrap {
  position: relative;
  width: 100px;
  height: 100px;
}
.donut-wrap svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}
.donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
}

/* ===== COMPETENCE DETAIL ===== */
.competence-detail { display: flex; flex-direction: column; gap: 20px; margin-bottom: 24px; }

.competence-section { }

.competence-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.competence-section-check {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid #1a9e6e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
}
.check-full     { background: #1a9e6e; border-color: #1a9e6e; color: #fff; }
.check-assimile { background: #3b82f6; border-color: #3b82f6; color: #fff; }
.check-partial  { background: #f59e0b; border-color: #f59e0b; color: #fff; }
.check-empty    { background: #fff; border-color: #e2e8f0; color: transparent; }

.competence-section-title { font-size: 14px; font-weight: 700; color: #1a1f2e; }

.competence-items { display: flex; flex-direction: column; gap: 8px; padding-left: 32px; }

.competence-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
}

.item-select {
  padding: 5px 24px 5px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E") no-repeat right 8px center;
  -webkit-appearance: none;
  color: #1a1f2e;
  cursor: pointer;
  outline: none;
  transition: border-color .15s;
  white-space: nowrap;
  flex-shrink: 0;
}
.item-select:focus { border-color: #1a9e6e; }
.item-select.parfait   { background-color: #e8f7f1; color: #065f46; border-color: #c3ead9; }
.item-select.assimile  { background-color: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }
.item-select.debutant  { background-color: #fef3c7; color: #b45309; border-color: #fde68a; }

.item-label { font-size: 13px; color: #64748b; }

.duree-restante {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  margin-left: auto;
  white-space: nowrap;
}

/* ===== TERMINER CARD ===== */
.terminer-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0,0,0,.06);
  max-width: 620px;
  margin: 0 auto 24px;
}

.terminer-section { margin-bottom: 28px; }

.terminer-section-label {
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.terminer-section-num {
  width: 24px;
  height: 24px;
  background: #3b82f6;
  color: #fff;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hours-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.hours-base  { font-size: 15px; font-weight: 700; color: #1a1f2e; }
.hours-plus  { color: #94a3b8; font-size: 14px; }
.hours-total { font-size: 14px; color: #64748b; }

.hours-number-input {
  width: 80px;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1f2e;
  outline: none;
  text-align: center;
  transition: border-color .15s;
}
.hours-number-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.08); }

.exam-form {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.exam-multiselect { min-width: 260px; }

.exam-form-hint {
  margin: 0;
  font-size: 12px;
  font-style: italic;
  color: #7a7168;
}

.success-block {
  margin-top: 10px;
  background: #e8f7f1;
  border: 1px solid #c3ead9;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #065f46;
}

.aac-validate-row { display: flex; gap: 10px; margin-top: 4px; }

.aac-result {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #ef4444;
}
.aac-result.success { color: #1a9e6e; }

.comment-area {
  width: 100%;
  min-height: 100px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1a1f2e;
  outline: none;
  resize: vertical;
  transition: border-color .15s;
}
.comment-area:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.08); }

.terminer-footer { display: flex; justify-content: center; margin-top: 8px; }

.btn-red            { background: #ef4444; color: #fff; }
.btn-red:hover      { background: #dc2626; transform: translateY(-1px); }

/* ===== HEURES PROGRAMMEES A VENIR ===== */
.heures-prog-list {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  max-height: 60vh;
  overflow-y: auto;
}

.heures-prog-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
  background: #ffffff;
  font-size: 14px;
  flex-wrap: wrap;
}

.heures-prog-row:last-child {
  border-bottom: none;
}

.heures-prog-row:hover {
  background: #f9fafb;
}

.heures-prog-date {
  color: #6b7280;
  min-width: 90px;
}

.heures-prog-heure {
  font-weight: 700;
  color: #1a1f2e;
  min-width: 130px;
}

.heures-prog-lieu {
  color: #111827;
}

.heures-prog-mono {
  color: #6b7280;
  font-style: italic;
}

.heures-prog-empty {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 14px;
}

/* ===== HISTORIQUE ===== */
.histo-item {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 14px;
  margin-bottom: 14px;
}
.histo-item:last-child { border-bottom: none; margin-bottom: 0; }

.histo-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
  margin-bottom: 6px;
}

.histo-body { font-size: 13px; color: #64748b; }

.histo-empty { font-style: italic; color: #94a3b8; }

/* ===== RESPONSIVE (mobile mono) ===== */
@media (max-width: 640px) {
  .fiche-cours { padding: 12px; }

  .cours-header-card {
    padding: 16px;
  }

  .cours-meta--grid {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }

  .cours-col-divider {
    width: 100%;
    height: 1px;
  }

  .cours-col-equation {
    justify-content: flex-start;
  }

  .heure-equation {
    gap: 6px;
  }

  .heure-equation .heure-box {
    padding: 4px 8px;
  }
}
</style>